//@ts-ignore
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Theme,
  createStyles,
  WithStyles,
  Grid,
  withStyles,
  Typography,
  Button,
} from '@material-ui/core';

import { getClient, getUsers } from '../../client/ClientServices';
import CourseData from '../../mylibrary/types/CourseData';
import courseService from '../../mylibrary/services/courseService';
import { MyPATSelect, MyPATTextField, MyPATDialog, MyPATIconButton, dateService } from '../../common';
import ReportsTable from './components/ReportsTable'
import moment from 'moment';
import Divider from '@material-ui/core/Divider';
import { serialize, getDiffOnTwoDates, validateEmail } from '../../../utils';
import { QUESTION_CREATE_REPORTS, generateQuestionReport, getQuestionList, getTestList } from './ReportsServices';
//import zipcelx from 'zipcelx';
import { bindActionCreators } from 'redux';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from '../../common/DatePicker';
import { connect } from "react-redux";
import ACLService from '../../acl/services/aclService';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import SearchBarWithChips from '../../course-Management/common/SearchBarWithChips';
import clientServices from '../../userManagement/services/userServices';
import { showMsg } from '../../course/actions/loaderAlert';
import { SELECT_ALL, SHOW_CHECKBOX } from '../../course-Management/Constants/constants';
import { NavLink as RouterLink, Route } from "react-router-dom";
const styles = (theme: Theme) => createStyles({
  btnExport: {
    background: '#1D7DEA',
    borderRadius: 4
  },
  calenderIcon: {
    zIndex: 2,
    position: 'absolute',
    right: 12,
    marginTop: 10
  },
  closeBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
    height: 60,
    padding: 8
  },
  datePickerContainer: {
    position: 'relative',
    '& input': {
      padding: '12px 15px 11px',
      background: 'rgb(255, 255, 255)',
      border: '1px solid rgb(223, 223, 223)',
      boxSizing: 'border-box',
      borderRadius: 4,
      width: '100%',
      outline: 0
    },
    '& .react-datepicker-wrapper': {
      width: '100%'
    },
    '& .react-datepicker__navigation--previous, .react-datepicker__navigation--next': {
      outline: 0
    }
  },
  iconRoot: {
    fill: theme.palette.text.secondary,
    margin: 0,
    width: '2rem',
    height: '2rem',
  },
  mb2x: {
    marginBottom: theme.spacing.unit * 2,
  },
  marginZero: {
    margin: 0
  },
  marginTop3x: {
    marginTop: 40
  },
  reportsFrame: {
    background: '#FFF',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.287534)',
    borderRadius: 4
  },
  paddingXS: {
    padding: '24px 16px'
  },
  titleText: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 36,
    lineHeight: '16px',
    color: 'rgb(51, 51, 51)',
    margin: '16px 0 25px 0', 
  },
  pageHeading: {
    paddingBottom: 20
  },
  label: {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '22px',
    color: '#333333'
  },
  letterSpaccingXS: {
    letterSpacing: 0.144385
  },
  marginBottomSM: {
    marginBottom: 8
  },
  padingSm: {
    padding: '30px 12px 0px'
  },
  cancelBtn: {
    background: '#FFF',
    color: '#1D7DEA',
    width: 132,
    marginRight: 6,
    border: '1px solid #1D7DEA',
    boxSizing: 'border-box',
    borderRadius: 2,
    fontWeight: 600,
    fontSize: '0.875rem'
  },
  sendBtn: {
    background: '#1D7DEA !important',
    color: '#fff !important',
    width: 132,
    border: '1px solid #1D7DEA',
    boxSizing: 'border-box',
    borderRadius: 2,
    fontWeight: 600,
    fontSize: '0.875rem'
  },
  disableBtn: {
    opacity: 0.4
  },
  paddingMD: {
    padding: 30
  },
  searchBarChips:{
    height: 'auto',
    '&>div:nth-of-type(1)':{
      border: "1px solid #dfdfdf",
      borderRadius: 4,
      padding: '0 5px',
      '&>div:nth-of-type(1)':{
        '&>div:nth-of-type(1)':{
          '&>div:nth-of-type(1)':{
            '&>div:nth-of-type(1)':{
              overflow: 'initial',
            }
          }
        }
      }
    },
    '& svg':{
      cursor: 'pointer'
    }
  },
  chipLabel:{
    fontSize:16,
    fontWeight:400,
    marginBottom: 10,
  },
  reportHeader: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 20,
    lineHeight: '16px',
    color: 'rgb(51, 51, 51)'
  },
  backButton: {
    color: '#333',
    fontFamily: 'Nunito',
    fontSize: '24px',
    fontWeight: 400,
  },
  backToHome: {
    textDecoration: 'none',
    color: '#333',
  },
  backButtonDiv: {
    display: "flex",
    columnGap: "10px",
    marginBottom: '25px',
  }
});

const convertDateFormat = (date: Date) => {
  return moment(date).format('YYYY-MM-DD')
}

export interface ReportsContainerProps extends WithStyles<typeof styles> {
  userData: any,
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any,
  showMsg: any,
  showBackButton?: boolean
}

export interface ReportsContainerState {
  clients: any[],
  startDt: any,
  isOpenCalender: boolean
}

let LIMIT: number = 10
let SKIP: number = 0
let TOTAL: number = 0

function ReportsContainer(props: ReportsContainerProps) {
  const [clients, setClients] = useState([])
  const [users, setUsers] = useState([])
  const [courses, setCourses] = useState([])
  const [clientId, setClient] = useState('')
  const [edpId, setEdpName] = useState(undefined)
  const [contentType, setContentType] = useState('')
  const [courseId, setCourseId] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [questionList, setQuestionList] = useState([])
  const [testList, setTestList] = useState([])
  const [emailReport, setEmailReport] = useState(false)
  const [emailId, setEmailId] = useState('')
  const [emailReportSended, setEmailReportSended] = useState(false)
  const [noDataFound, setNoDataFound] = useState(false)
  const [isOpenCalender] = useState(false)
  const [selectedClient, setSelectedClient] = useState('');
  const [userTypeList, setUserTypeList] = useState([]);
  const [selectedUserTypeId, setSelectedUserTypeId] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState([]);
  const [selectedClientOption, setselectedClientOption] = useState([]);
  const [selectedUserTypeOption, setSelectedUserTypeOption] = useState([]);
  const [isUserTypeDisabled, setisUserTypeDisabled] = useState(false);
  const { showBackButton = true } = props

  useEffect(() => {
    getClient('source=report')
      .then((res: any) => {
        if (((res || {}).responseObject || []).length) {
          let clientList = res.responseObject || [];
          clientList = clientList.filter((userType: any) => (userType.schoolOrg && userType.schoolOrg.id) === QUESTION_CREATE_REPORTS.SCHOOL_ORG.id);
          if (clientList.length === 1) {
            const item = clientList[0];
            const selectedValue = [{ value: item._id, label: item.name, id: item._id }];
            handleMultiSelectClient(selectedValue);
          }
          clientList = [{ name: SELECT_ALL.LABEL, _id: SELECT_ALL.VALUE }, ...clientList];
          setClients(clientList);
        }
      })
    courseService
      .list()
      .then((courses: CourseData[]) => setCourses(courses));
    props.setLoggedInUser();
  }, [])

  const selectClient = (e: any) => {
    setClient(e.target.value)
    setEdpName('')
    getUsers(e.target.value)
      .then((res: any) => {
        const users = res.responseObject
        setUsers(users)
      })
      .catch()
  }
  const validateDate = () => {
    return getDiffOnTwoDates(convertDateFormat(startDate), convertDateFormat(endDate)) >= 0;
  }
  const validations = (): boolean => {
    // const isContentTypeValid = contentType == 'question' ? true : courseId ? true : false
    return selectedClientId && ((selectedUserTypeOption && selectedUserTypeOption.length) || ( selectedUserTypeOption && selectedUserTypeOption.length === 1 && ((selectedUserTypeOption || [])[0]|| {}).id === 'All'))
     && startDate && endDate && validateDate() ? false : true;
  }

  const loadQuestionList = async (emailId?: string) => {
    const paramsObj = {
      startDate: convertDateFormat(startDate),
      endDate: convertDateFormat(endDate),
      edpId,
      limit: LIMIT,
      skip: SKIP
    }
    if (emailId) {
      //@ts-ignore
      paramsObj['email'] = emailId;
      delete paramsObj["limit"];
      delete paramsObj["skip"];
    }
    try {
      const questionList: any = await getQuestionList(clientId, serialize(paramsObj))
      if (emailId) {
        setEmailReportSended(true)
      } else {
        if (SKIP === 0) {
          TOTAL = questionList.data.recordCount
          if (questionList.responseObject.length === 0) {
            setNoDataFound(true)
          }
        }
        setQuestionList(questionList.responseObject)
      }
    } catch (error) {
    }
  }

  const loadTestList = async (emailId?: string) => {
    const paramsObj = {
      startDate: convertDateFormat(startDate),
      endDate: convertDateFormat(endDate),
      edpId,
      courseId,
      limit: LIMIT,
      skip: SKIP
    }
    if (emailId) {
      //@ts-ignore
      paramsObj['email'] = emailId;
      delete paramsObj["limit"];
      delete paramsObj["skip"];
    }
    try {
      const testList: any = await getTestList(clientId, serialize(paramsObj))
      if (emailId) {
        setEmailReportSended(true)
      } else {
        if (SKIP === 0) {
          TOTAL = testList.data.recordCount
          if (testList.responseObject.length === 0) {
            setNoDataFound(true)
          }
        }
        setTestList(testList.responseObject) 
      }
    } catch (error) {

    }
  }

  const loadList = (page: number) => {
    SKIP = page
    if (contentType == 'question') {
      loadQuestionList()
    } else {
      loadTestList()
    }
  }


  const resetDefault = () => {
    // basic reset functionality

    setQuestionList([])
    setTestList([])
    setEmailReport(false)
  }

  const generateReport = () => {
    SKIP = 0;
    resetDefault()
    // if (getDiffOnTwoDates(convertDateFormat(startDate), convertDateFormat(endDate)) > 30) {
    //   setEmailReport(true)
    // }
    // else if (contentType == 'question') {
    //   loadQuestionList()
    // } else {
    //   loadTestList()
    // }
    const payload = {
      clientIds: selectedClientId,
      roleIds: selectedClientId.length === 1 ? selectedUserTypeId : [],
      startDate: convertDateFormat(startDate),
      endDate: convertDateFormat(endDate)
    }

    generateQuestionReport(payload).then((res:any) => {
      props.showMsg(res.responseMessage,'success'); 
    })
    
  }

  const sendReport = () => {
    if (contentType === 'question') {
      loadQuestionList(emailId)
    } else {
      loadTestList(emailId)
    }
  }

  const resetSendEmailState = () => {
    setClient('')
    setEdpName('')
    setContentType('')
    setCourseId('')
    setStartDate(new Date())
    setEndDate(new Date())
    setEmailId('')
    setEmailReport(false)
    setEmailReportSended(false)
  }

  const exportDataMethod = (keys: any, dataList: any) => {
    const config: any = {
      filename: `${moment(startDate).format("Do MMMM YYYY")}_to_${moment(endDate).format("Do MMMM YYYY")}_report`,
      sheet: {
        data: [
          keys,
          ...dataList
        ]
      }
    };
    //zipcelx(config);
  }

  const handleExport = async () => {
    if(props.isPostExpiryDays){
       props.toggleLicenseExpiredDialog(true);
    } else {
      const paramsObj = {
        startDate: convertDateFormat(startDate),
        endDate: convertDateFormat(endDate),
        edpId,
      }
      let dataList = []
      let keys = [
        {
          value: 'S.No',
          type: 'string'
        }, {
          value: 'Created By',
          type: 'string'
        },
        {
          value: 'Question ID',
          type: 'string'
        },
        {
          value: 'Question Type',
          type: 'string'
        },
        {
          value: 'All Tags',
          type: 'string'
        },
        {
          value: 'Status',
          type: 'string'
        },
        {
          value: 'Created Date',
          type: 'string'
        },
        {
          value: 'First Published Date',
          type: 'string'
        },
        {
          value: 'Updated Date',
          type: 'string'
        }
      ];
      if (contentType === 'question') {
        try {
          const questionList: any = await getQuestionList(clientId, serialize(paramsObj))
          dataList = questionList.responseObject.map((cell: any, index: number) => {
            return [
              {
                value: index + 1,
                type: 'number'
              },
              {
                value: `${cell.firstName} ${cell.lastName}`,
                type: 'string'
              },
              {
                value: cell.contentId,
                type: 'string'
              },
              {
                value: cell.questionType,
                type: 'string'
              },
              {
                value: cell.tags.join(" ,"),
                type: 'string'
              },
              {
                value: cell.status,
                type: 'string'
              },
              {
                value: moment(cell.createdAt).format('D MMMM  YYYY'),
                type: 'string'
              },
              {
                value: cell.firstPublishDate ? moment(cell.firstPublishDate).format('D MMMM  YYYY') : '',
                type: 'string'
              },
              {
                value: moment(cell.updatedAt).format('D MMMM  YYYY'),
                type: 'string'
              }
            ]
          })
  
          exportDataMethod(keys, dataList);
        } catch (error) {
        }
      } else {
        //@ts-ignore
        paramsObj['courseId'] = courseId
        keys = [
          {
            value: 'S.No',
            type: 'string'
          }, {
            value: 'Created By',
            type: 'string'
          },
          {
            value: 'Test ID',
            type: 'string'
          },
          {
            value: 'All Tags',
            type: 'string'
          },
          {
            value: 'Status',
            type: 'string'
          },
          {
            value: 'Created Date',
            type: 'string'
          },
          {
            value: 'First Published Date',
            type: 'string'
          },
          {
            value: 'Updated Date',
            type: 'string'
          },
          {
            value: 'Goal',
            type: 'string'
          }
        ]
        try {
          const testList: any = await getTestList(clientId, serialize(paramsObj))
          dataList = testList.responseObject.map((cell: any, index: number) => {
            return [
              {
                value: index + 1,
                type: 'number'
              },
              {
                value: `${cell.firstName} ${cell.lastName}`,
                type: 'string'
              },
              {
                value: cell.contentId,
                type: 'string'
              },
              {
                value: cell.tags.join(" ,"),
                type: 'string'
              },
              {
                value: cell.status,
                type: 'string'
              },
              {
                value: moment(cell.createdAt).format('D MMMM  YYYY'),
                type: 'string'
              },
              {
                value: cell.firstPublishDate ? moment(cell.firstPublishDate).format('D MMMM  YYYY') : moment(cell.updatedAt).format('D MMMM  YYYY'),
                type: 'string'
              },
              {
                value: moment(cell.updatedAt).format('D MMMM  YYYY'),
                type: 'string'
              },
              {
                value: cell.goalName,
                type: 'string'
              }
            ]
          })
          exportDataMethod(keys, dataList);
        } catch (error) {
  
        }
      }
    }
  }

  const handleMultiSelectClient = (optionname: any) => {
    if(optionname && optionname.length === 1){
      setSelectedClient(optionname);
        setSelectedUserTypeOption(null);
       clientServices.getRolesListWithoutPagination(optionname[0].id, false).then(res => {
        let userTypeList =( res && res.roleData ) || [];
        userTypeList = userTypeList.filter((userType: any) => userType && userType.isReportAllow); 
        userTypeList =userTypeList.map((userType:any) => (
          { value: userType._id, label: userType.role, id: userType._id }));
        if ((userTypeList || []).length) {
          userTypeList.unshift({ value: SELECT_ALL.VALUE, label: SELECT_ALL.LABEL, id: SELECT_ALL.VALUE });
        }
        setUserTypeList(userTypeList);
      })
    } else {
      setSelectedClient(optionname);
      if(optionname && optionname.length > 1){
      setSelectedUserTypeOption([{id:'All',label:'All',value:'All'}]);
      }
      if(optionname && !optionname.length){
        setSelectedUserTypeOption(null);
      }
    }
    const selectedClientId = optionname && optionname.length && optionname.filter((item: any) => item.id !== SELECT_ALL.VALUE).map((item: any) => (item.id));
    setSelectedClientId(selectedClientId);
  }

  const handleMultiSelectUserType = (selectedValue: any) => {
    setSelectedUserTypeOption(selectedValue);
    const selectedUserRoleId = selectedValue && selectedValue.length && selectedValue.filter((item: any) => item.id !== SELECT_ALL.VALUE).map((item: any) => (item.id));
    setSelectedUserTypeId(selectedUserRoleId);
  }


  const getUserTypeBar = () => {
    return (<SearchBarWithChips
      suggestions={userTypeList}
      placeholderText="Select User Type"
      onSelection={handleMultiSelectUserType}
      classes={{ root: classes.searchBarChips }}
      backspaceRemoves={true}
      notFound="No User Type Found"
      values={selectedUserTypeOption}
      disabled={!selectedClientId ||   selectedClientId.length !== 1}
      source={SHOW_CHECKBOX}
    />);
  }

  const {
    classes,
  } = props;
  return (
    <>
      <Grid className={classes.mb2x} container spacing={8} alignItems="center" justify="space-between">
        <Grid item xs="auto">
          <Typography variant="h6"
            className={classes.titleText}>
            Question Creation Report
            </Typography>
        </Grid>
        {/* <Grid item xs="auto">
          <Button
            variant="contained"
            color="primary"
            disabled={!(questionList.length > 0 || testList.length > 0 || ACLService.checkModulePermission("edp", "download"))}
            className={classes.btnExport}
            onClick={() => handleExport()}
            disableRipple
          >
            Export
          </Button>
        </Grid> */}
      </Grid>
      {showBackButton && (<Grid>
        <div className={classes.backButton}>
        <RouterLink
            exact
            to="/reports"
            className={classes.backToHome}
          >
            <Route
              path="/reports"
              children={({}) => (
                <>
                <div className={classes.backButtonDiv}>
                  <img src="/assets/svg/left-arrow-1.svg" alt="Back" />
                  Back
                </div>
                </>
              )}
            />
          </RouterLink>
         </div>
      </Grid>)}
      <Grid >

        <Grid container className={classes.reportsFrame}>
          <Grid item xs={12}>
            <Typography variant="h6"
              component="body2"
              className={[classes.reportHeader, classes.paddingXS].join(' ')}>
              Reports Details
              </Typography>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Grid container className={classes.paddingXS} spacing={32}>
              {/* <Grid item xs={6}>
                <MyPATSelect
                  label={'Client Name'}
                  inputId={'Client Name'}
                  name={'Client Name'}
                  value={clientId}
                  onChange={selectClient}
                  fullWidthControl
                  error={''}
                  errorText={''}
                >
                  <option value=""> Select Client</option>
                  {
                    clients.map((client: any) => {
                      return <option value={client._id}> {client.name} </option>
                    })
                  }
                </MyPATSelect>
              </Grid> */}
              <Grid item xs={3}>             
              <Grid>             
                 <Typography className={classes.chipLabel}>Client Name</Typography>
                <div>
                  <SearchBarWithChips
                    suggestions={(clients || []).map((item: any) => ({ value: item._id, label: item.name, id: item._id }))}
                    placeholderText='Select Client Name'
                    onSelection={handleMultiSelectClient}
                    classes={{ root: classes.searchBarChips }}
                    backspaceRemoves={true}
                    notFound="No Client Found"
                    values={selectedClient}
                    source={SHOW_CHECKBOX}
                  />
                </div>
              </Grid>
                
              </Grid>
              <Grid item xs={3}>
                <Typography className={classes.chipLabel}>User Type</Typography>
                <div>
                  {getUserTypeBar()}
                </div>
              </Grid>
                
              {/* <Grid item xs={6}>
                <MyPATSelect
                  label={'EDP Name'}
                  inputId={'EDP Name'}
                  name={'EDP Name'}
                  value={edpId}
                  onChange={(e: any) => { setEdpName(e.target.value) }}
                  fullWidthControl
                  error={''}
                  errorText={''}
                >
                  <option value={undefined}>All</option>
                  {
                    users.map((user: any) => {
                      return <option value={user._id}> {`${user.firstName} ${user.lastName}`} </option>
                    })
                  }
                </MyPATSelect>
              </Grid> */}

              {/* <Grid item xs={6}>
                <MyPATSelect
                  label={'Content Type'}
                  inputId={'Content Type'}
                  name={'Content Type'}
                  value={contentType}
                  onChange={(e: any) => { setContentType(e.target.value) }}
                  fullWidthControl
                  error={''}
                  errorText={''}
                >
                  <option value=""> Select Content Type </option>
                  <option value="question"> Question </option>
                  <option value="test"> Test </option>
                </MyPATSelect>
              </Grid> */}
              {
                // goal enable only for test type
                contentType == 'test' &&
                <Grid item xs={6}>
                  <MyPATSelect
                    label="Goal"
                    inputId="goal"
                    name="goal"
                    value={courseId}
                    onChange={(e: any) => { setCourseId(e.target.value) }}
                    fullWidthControl
                    error={''}
                    errorText={''}
                  >
                    <option value="">Select</option>
                    {_.map(courses, (course, index) => (
                      <option
                        value={course.groupId}
                        data-optionname={course.courseType.name}
                        key={index}
                      >
                        {course.courseType.name}
                      </option>
                    ))}
                  </MyPATSelect>
                </Grid>
              }
              <Grid item xs={6}>
                <p className={[classes.marginZero, classes.label, classes.chipLabel].join(' ')}>Date
                      <span style={{ color: 'red' }}>
                    &nbsp;&nbsp;{!validateDate() ? 'Select smaller start date!' : ''}
                  </span>
                </p>
                <Grid container spacing={8}>
                  <Grid item xs={6}>
                    <Grid container alignItems="center">
                      <Grid item className={classes.label}>From &nbsp;&nbsp;
                      </Grid>
                      <Grid item xs={9} className={classes.datePickerContainer}>
                        <DatePicker
                          dateFormat="dd MMMM yyyy"
                          selected={startDate}
                          maxDate={new Date()}
                          onChange={(date) => { setStartDate(date) }}
                          startOpen={isOpenCalender}
                          classes={classes.calenderIcon}
                          id="startDate"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={6}>
                    <Grid container alignItems="center">
                      <Grid item className={classes.label}>To &nbsp;&nbsp;</Grid>
                      <Grid item xs={9} className={classes.datePickerContainer}>
                        <DatePicker
                          dateFormat="dd MMMM yyyy"
                          selected={endDate}
                          maxDate={new Date()}
                          onChange={(date) => { setEndDate(date) }}
                          startOpen={isOpenCalender}
                          classes={classes.calenderIcon}
                          id="endDate"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Button disabled={validations()} onClick={generateReport} 
                  color="primary" variant="contained" disableRipple>
                    Download Report
                </Button>
                </Grid>
              </Grid>
              {
                (questionList.length > 0 || testList.length > 0)
                && <ReportsTable
                  questions={questionList}
                  tests={testList}
                  contentType={contentType}
                  test={testList}
                  loadList={loadList}
                  total={TOTAL}
                />
              }
              <MyPATDialog
                dialogOpen={emailReport}
                dialogHeading={
                  emailReportSended
                    ?
                    'Email Sent Successfully'
                    :
                    ' '}
                otherDialogProps={{
                  maxWidth: false
                }}
                isborderDialogAction={true}
                onDialogClose={resetSendEmailState}
                customDialogActions={
                  <Grid container justify="center" spacing={24} alignItems="center" className={classes.mb2x}>
                    {!emailReportSended ?
                      <>
                        <Grid item>
                          <Button
                            classes={{ root: classes.cancelBtn }}
                            onClick={() => { setEmailReport(false) }}>
                            Cancel
                        </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            onClick={sendReport}
                            disabled={!validateEmail(emailId)}
                            classes={{ root: classes.sendBtn, disabled: classes.disableBtn }}
                          >
                            Send
                          </Button>
                        </Grid>
                      </>
                      :
                      <>
                        <Grid item>
                          <Button
                            onClick={resetSendEmailState}
                            classes={{ root: classes.sendBtn, disabled: classes.disableBtn }}
                          >
                            Done
                        </Button>
                        </Grid>
                      </>
                    } </Grid>
                }
              >
                <div style={{ width: 446 }}>
                  {!emailReportSended
                    ?
                    <>
                      <Grid container justify="center" alignItems="center">
                        <Grid item>
                          <Typography variant="body1" align="center" className={[classes.label, classes.letterSpaccingXS].join(' ')}>
                            The date range you have selected is more then one month.
                            An Email will be sent with the report to the given Id.
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Grid container justify="center" alignItems="center" className={classes.padingSm}>
                            <Grid item>
                              <Typography variant="body1" align="left" className={[classes.label, classes.marginBottomSM].join(' ')}>Enter Email Id &nbsp;&nbsp;
                        </Typography>
                            </Grid>
                            <Grid item>
                              <MyPATTextField
                                inputId="emailId"
                                name="emailId"
                                value={emailId}
                                onChange={(e: any) => { setEmailId(e.target.value) }}
                                required
                                fullWidthControl
                                error={''}
                                errorText={''}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                    :
                    <>
                      <Grid container justify="center" alignItems="center">
                        <Grid item className={classes.paddingMD}>
                          <img src="/assets/svg/email-sent.svg" alt="sentEmail" />
                        </Grid>
                        <Grid item>
                          <Typography variant="body1" align="center" className={[classes.label, classes.letterSpaccingXS].join(' ')}>
                            The Email was sent successfully. Check your Inbox for the detail report.
                          </Typography>
                        </Grid>
                      </Grid>
                    </>
                  }
                </div>
              </MyPATDialog>
              <MyPATDialog
                dialogOpen={noDataFound}
                dialogHeading={
                  emailReportSended
                    ?
                    'Record not found'
                    :
                    ' '}
                otherDialogProps={{
                  maxWidth: false
                }}
                isborderDialogAction={true}
                onDialogClose={() => { setNoDataFound(false) }}
                customDialogActions={
                  <Grid container justify="center" spacing={24} alignItems="center" className={classes.mb2x}>

                    <Grid item>
                      <Button
                        onClick={() => { setNoDataFound(false) }}
                        classes={{ root: classes.sendBtn, disabled: classes.disableBtn }}
                      >
                        Ok
                        </Button>
                    </Grid>
                  </Grid>
                }
              >
                <div style={{ width: 446 }}>
                  <Grid container justify="center" alignItems="center">
                    <Grid item className={classes.paddingMD}>
                      <img src="/assets/svg/warning.svg" alt="error" />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" align="center" className={[classes.label, classes.letterSpaccingXS].join(' ')}>
                        The record for the selected date is not found.
                          </Typography>
                    </Grid>
                  </Grid>

                </div>
              </MyPATDialog>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}




const mapStateToProps = (state: any) => ({
  userData: state.loginData.userData,
  loggedInUserData:  state.loginData.userData &&  state.loginData.userData.loggedInUserData,
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  toggleLicenseExpiredDialog,
  setLoggedInUser,
  showMsg: showMsg
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ReportsContainer));